'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/strict-uri-encode/index.js
// module id = 238
// module chunks = 1 4 6